<div class="row">
  <div class="col-lg-12">
    <div class="row main-container" [ngClass]="{'toggle' : document.body.clientWidth < 768}">
      <div class="col-xl-2 d-xl-inline navigation-panel">
        <div class="overflow-x-hidden overflow-y-auto scrollbar" style="max-height: calc(100vh - 57px);">
          <div class="row">
            <!--  favorites  -->
            <div class="col-lg-12 my-2">
              <h6 data-bs-toggle="collapse" href="#favorites" role="button"
                  aria-expanded="{{expandFavorites}}" aria-controls="favorites"
                  (click)="expandFavorites = !expandFavorites">
                <span class="icon icon24"
                      [ngClass]="expandFavorites ? 'expand-arrow':'more-then-arrow'"></span>{{ 'app.labels.favorites' | translate }}
              </h6>
              <div class="collapse multi-collapse" id="favorites" [ngClass]="{'show' : expandFavorites}">
                <div class="cursor-pointer my-1" *ngFor="let f of folderService.getFolders()"
                     (click)="openFolder(f)"
                     [ngClass]="{ 'd-none' : !folderService.getAttributeValue(f.attributes, folderService.favoriteAttrId, false), 'active' : apiService.getParam('$folder') === f.id}">
                  <div class="row justify-content-between">
                    <div class="col text-truncate">
                      <span class="icon icon24" [ngClass]="f.icon"></span>{{ f.name | translate }}
                      ({{ getStat(f.id, 'folder_id').count }})
                    </div>
                    <div class="col text-truncate text-end">
                      <small>
                        ${{ format(abs(getStat(f.id, 'folder_id').invest)) }}
                        <span [ngClass]="getStat(f.id, 'folder_id').profit > 0 ? 'text-success' : 'text-danger'">
                          [${{ format(abs(getStat(f.id, 'folder_id').profit)) }}]
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="cursor-pointer my-1" *ngFor="let a of accountService.getAccounts()"
                     (click)="openAccount(a)"
                     [ngClass]="{ 'd-none' : !a.favorite, 'active' : apiService.getParam('$account') === a.id}">
                  <div class="row justify-content-between">
                    <div class="col text-truncate">
                      <span class="icon icon24" [ngClass]="a.icon"></span>{{ a.name | translate }}
                      ({{ getStat(a.id, 'account_id').count }})
                    </div>
                    <div class="col text-truncate text-end">
                      <small>
                        ${{ format(abs(getStat(a.id, 'account_id').invest)) }}
                        <span [ngClass]="getStat(a.id, 'account_id').profit > 0 ? 'text-success' : 'text-danger'">
                          [${{ format(abs(getStat(a.id, 'account_id').profit)) }}]
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--  accounts  -->
            <div class="col-lg-12 mb-2">
              <h6 data-bs-toggle="collapse" href="#accounts" role="button"
                  aria-expanded="{{expandAccounts}}" aria-controls="accounts"
                  (click)="expandAccounts = !expandAccounts">
                <span class="icon icon24"
                      [ngClass]="expandAccounts ? 'expand-arrow':'more-then-arrow'"></span>{{ 'app.labels.accounts' | translate }}
              </h6>
              <div class="collapse multi-collapse" id="accounts" [ngClass]="{'show' : expandAccounts}">
                <div class="cursor-pointer my-1" *ngFor="let e of accountService.getAccounts()" (contextmenu)="false"
                     (click)="openAccount(e)" [ngClass]="{active : apiService.getParam('$account') == e.id}">
                  <div class="row justify-content-between">
                    <div class="col text-truncate">
                      <span class="icon icon24" [ngClass]="e.icon"></span>{{ e.name }}
                      ({{ getStat(e.id, 'account_id').count }})
                    </div>
                    <div class="col text-truncate text-end">
                      <small>
                        ${{ format(abs(getStat(e.id, 'account_id').invest)) }}
                        <span [ngClass]="getStat(e.id, 'account_id').profit > 0 ? 'text-success' : 'text-danger'">
                          [${{ format(abs(getStat(e.id, 'account_id').profit)) }}]
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cursor-pointer my-1 link-primary" data-bs-toggle="modal" data-bs-target="#addAccount">
                <span class="icon icon24"></span>{{ 'app.buttons.add.account' | translate }}
              </div>
            </div>

            <!--  all folders  -->
            <div class="col-lg-12 mb-2">
              <h6 data-bs-toggle="collapse" href="#folders" role="button"
                  aria-expanded="{{expandFolders}}" aria-controls="folders"
                  (click)="expandFolders = !expandFolders">
                <span class="icon icon24"
                      [ngClass]="expandFolders ? 'expand-arrow':'more-then-arrow'"></span>{{ 'app.labels.folders' | translate }}
              </h6>
              <div class="collapse multi-collapse" id="folders" [ngClass]="{'show' : expandFolders}">
                <div class="cursor-pointer my-1" *ngFor="let f of folderService.getFolders()"
                     (click)="openFolder(f)"
                     [ngClass]="{ 'active' : apiService.getParam('$folder') === f.id }">
                  <div class="row justify-content-between">
                    <div class="col text-truncate">
                      <span class="icon icon24" [ngClass]="f.icon"></span>{{ f.name | translate }}
                      ({{ getStat(f.id, 'folder_id').count }})
                    </div>
                    <div class="col text-truncate text-end">
                      <small>
                        ${{ format(abs(getStat(f.id, 'folder_id').invest)) }}
                        <span [ngClass]="getStat(f.id, 'folder_id').profit > 0 ? 'text-success' : 'text-danger'">
                          [${{ format(abs(getStat(f.id, 'folder_id').profit)) }}]
                        </span>
                      </small>
                    </div>
                  </div>
                </div>

                <div class="cursor-pointer my-1 link-primary" data-bs-toggle="modal" data-bs-target="#addFolder">
                  <span class="icon icon24"></span>{{ 'app.buttons.add.folder' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-xl-10 main-content">
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex justify-content-between mb-2 mt-2">
              <div class="btn-group" role="group">
                <button class="btn btn-white btn-sm" (click)="navigationPanel()">
                  <span class="icon icon24 menu"></span>
                </button>

                <button class="btn btn-primary btn-sm" (click)="addDeal()">
                  <span class="icon icon24 add"></span><span class="d-none d-lg-inline"
                                                             translate>app.deal.button.add</span>
                </button>
                <button [disabled]="getSelectedDealCount() === 0" class="btn btn-white btn-sm"
                        type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="icon icon24 move-to"></span><span class="d-none d-lg-inline"
                                                                 translate>app.deal.button.move2folder</span>
                </button>
                <ul class="dropdown-menu p-2">
                  <li *ngFor="let f of folderService.getFolders()" [ngClass]="{ 'd-none' : f.system }"
                      (click)="moveTo(f)">
                    <a class="dropdown-item" translate>{{ f.name }}</a>
                  </li>
                </ul>
                <button [disabled]="getSelectedDealCount() === 0" class="btn btn-white btn-sm"
                        type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="icon icon24 move-to"></span><span class="d-none d-lg-inline"
                                                                 translate>app.deal.button.move2account</span>
                </button>
                <ul class="dropdown-menu p-2">
                  <li *ngFor="let a of accountService.getAccounts()" (click)="moveToAccount(a)">
                    <a class="dropdown-item" translate>{{ a.name }}</a>
                  </li>
                </ul>
                <button [disabled]="getSelectedDealCount() === 0" class="btn btn-white btn-sm"
                        type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="icon icon24 color"></span><span class="d-none d-lg-inline"
                                                               translate>app.deal.button.color</span>
                </button>
                <ul class="dropdown-menu p-2">
                  <li *ngFor="let color of colors" [style.color]="color.color"
                      (click)="colorDeals(color.color)">
                    <span class="dropdown-item icon icon24 color"
                          [style.color]="color.color"></span>{{ color.name }}
                  </li>
                </ul>
                <button [disabled]="getSelectedDealCount() === 0" class="btn btn-white btn-sm"
                        (click)="attrDeals(!hasSelectedAttr(dealService.hiddenAttrId), dealService.hiddenAttrId)">
                  <span class="icon icon24"
                        [ngClass]="hasSelectedAttr(dealService.hiddenAttrId) ? 'eye-hide' : 'eye'"></span>
                  <span class="d-none d-lg-inline">
                    {{
                      (hasSelectedAttr(
                        dealService.hiddenAttrId)? 'app.deal.button.show' : 'app.deal.button.hide') | translate
                    }}
                  </span>
                </button>
                <button [disabled]="getSelectedDealCount() === 0" class="btn btn-white btn-sm"
                        (click)="attrDeals(!hasSelectedAttr(dealService.pinnedAttrId), dealService.pinnedAttrId)">
                  <span class="icon icon24"
                        [ngClass]="hasSelectedAttr(dealService.pinnedAttrId) ? 'pin-filled' : 'pin'"></span>
                  <span class="d-none d-lg-inline">
                    {{
                      (hasSelectedAttr(
                        dealService.pinnedAttrId)? 'app.deal.button.unpin' : 'app.deal.button.pin') | translate
                    }}
                  </span>
                </button>
                <button [disabled]="getSelectedDealCount() === 0" class="btn btn-white btn-sm"
                        (click)="attrDeals(!hasSelectedAttr(dealService.favoriteAttrId), dealService.favoriteAttrId)">
                  <span class="icon icon24"
                        [ngClass]="hasSelectedAttr(dealService.favoriteAttrId) ? 'star-filled' : 'star'"></span>
                  <span class="d-none d-lg-inline">
                    {{
                      (hasSelectedAttr(
                        dealService.favoriteAttrId)? 'app.deal.button.unfavorite' : 'app.deal.button.favorite') | translate
                    }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-7 col-xl-6" [ngClass]="{'d-none' : isVisible('deal')}">
            <div class="block border">
              <div class="row">
                <div class="col-sm-12">
                  <div class="border-bottom p-2">
                    <div class="row align-items-center">
                      <div class="col overflow-hidden">
                        <div style="margin-left: 4px;" class="icon icon24 checked-checkbox"
                             (click)="masterCheckboxClick()"></div>
                        {{ getSelectedContainer().name | translate }}
                        <div class="icon icon24" [ngClass]="isFavoriteSelectedContainer() ? 'star-filled' : 'star'"
                             *ngIf="this.apiService.getParam('$folder') != 'all' && this.apiService.getParam('$folder') != 'new'"
                             (click)="toggleFavorite()"></div>
                      </div>
                      <div class="col">
                        <div class="input-group input-group-sm dropdown-center">
                          <label class="input-group-text d-lg-inline" for="search">
                            <span class="icon icon24 search"></span>
                          </label>
                          <input type="text" placeholder="Ticker OR formula" [(ngModel)]="search" maxlength="20"
                                 id="search" autocomplete="off" class="form-control"/>
                          <button class="input-group-text btn btn-white btn-sm z-0" type="button"
                                  data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="icon icon24 question"></span>
                            <div class="dropdown-menu p-2">
                              You can use ticker name case insensitive.<br/><br/>
                              Formula examples:<br/>
                              ">10%" deals which price increased on 10%<br/>
                              "<-10%" deals which price decreased on -10%<br/>
                              ">10% && <20%" deals which price increased on 10% and less then 20%<br/>
                              ">-20% && <-10%" deals which price decreased on -20% and less then -10%<br/><br/>
                              <strong>Don't use ticker and formula at the same time!</strong>
                            </div>
                          </button>
                        </div>
                      </div>
                      <div class="col">
                        <div class="btn-group float-end">
                          <button class="btn btn-white btn-sm" type="button" data-bs-toggle="dropdown"
                                  aria-expanded="false">
                            <span class="icon icon24 sort"></span>
                            <span class="d-xl-inline d-none">Sort</span>
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end">
                            <li>
                              <a class="dropdown-item disabled">Sort by</a>
                            </li>
                            <li (click)="changeSortFieldState('priority')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: sortConfig.field === 'priority'}"></span>Priority
                              </a>
                            </li>
                            <li (click)="changeSortFieldState('profit')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: sortConfig.field === 'profit'}"></span>Profit
                              </a>
                            </li>
                            <li (click)="changeSortFieldState('created')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: sortConfig.field === 'created'}"></span>Date
                              </a>
                            </li>
                            <li (click)="changeSortFieldState('ticker')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: sortConfig.field === 'ticker'}"></span>Ticker
                              </a>
                            </li>
                            <li>
                              <hr class="dropdown-divider"/>
                            </li>
                            <li>
                              <a class="dropdown-item disabled">Sort order</a>
                            </li>
                            <li (click)="changeSortDirectionState('asc')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: sortConfig.direction === 'asc'}"></span>Newest
                                on top
                              </a>
                            </li>
                            <li (click)="changeSortDirectionState('desc')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: sortConfig.direction === 'desc'}"></span>Oldest
                                on top
                              </a>
                            </li>
                          </ul>
                          <button class="btn btn-white btn-sm" type="button" data-bs-toggle="dropdown"
                                  aria-expanded="false">
                            <span class="icon icon24 filter"></span>
                            <span class="d-xl-inline d-none">Filter</span>
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end">
                            <li (click)="changeFilterState('favorites')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: filterConfig.favorites}"></span>Favorites
                              </a>
                            </li>
                            <li (click)="changeFilterState('increased')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: filterConfig.increased}"></span>Increased
                                deals
                              </a>
                            </li>
                            <li (click)="changeFilterState('decreased')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: filterConfig.decreased}"></span>Decreased
                                deals
                              </a>
                            </li>
                            <li (click)="changeFilterState('pinned')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: filterConfig.pinned}"></span>Pinned
                              </a>
                            </li>
                            <li (click)="changeFilterState('inOrder')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: filterConfig.inOrder}"></span>In order
                              </a>
                            </li>
                            <li (click)="changeFilterState('hasComment')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: filterConfig.hasComment}"></span>Has comment
                              </a>
                            </li>
                            <li (click)="changeFilterState('hidden')">
                              <a class="dropdown-item cursor-pointer">
                                <span class="icon icon24" [ngClass]="{done: filterConfig.hidden}"></span>Hidden
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="overflow-x-hidden overflow-y-auto scrollbar" style="height: calc(100vh - 189px);">
                    <div *ngIf="getGroups().length === 0" class="text-center">
                      <h5 *ngIf="accountService.getAccounts().length === 0" class="my-5">
                        First of all <a class="link-primary cursor-pointer" data-bs-toggle="modal"
                                        data-bs-target="#addAccount">create your account</a>
                      </h5>

                      <div class="icon icon24 no-deal my-5" style="transform: scale(5); opacity: .7"></div>
                      <p>
                        Nothing in folder
                        <br/>
                        Looks empty over here.
                      </p>
                    </div>
                    <div *ngFor="let group of getGroups()">
                      <div class="row border-bottom cursor-pointer align-items-center pe-2 deal"
                           *ngIf="group.deals.length > 1">
                        <div class="col-5 overflow-hidden text-truncate ml--4"
                             (click)="group.expandGroup = !group.expandGroup">
                          <div class="icon icon24"
                               [ngClass]="group.expandGroup ? 'expand-arrow' : 'more-then-arrow'"></div>

                          <div class="d-inline">
                            {{ group.fromToken() }}
                            <span class="d-lg-inline d-none">
                              {{ group.toToken() }}
                            </span>
                          </div>
                        </div>

                        <div class="col-2" (click)="group.expandGroup = !group.expandGroup">
                          <span [ngClass]="group.profit() > 0 ? 'text-success' : 'text-danger'">
                            ${{ format(abs(group.profit())) }}
                          </span>
                          <small class="text-muted d-block mt--4">
                            ${{ format(group.totalSum()) }}
                          </small>
                        </div>

                        <div class="col-2" (click)="group.expandGroup = !group.expandGroup">
                          <span [ngClass]="group.profit() > 0 ? 'text-success' : 'text-danger'">
                            {{
                              abs(((group.deals[0].last_price / group.price()) * 100) - 100) | number:rudePriceFormat
                            }}%
                          </span>
                          <small class="text-muted d-block mt--4">
                            {{ format(group.quantity()) }}
                          </small>
                        </div>

                        <div class="col text-end">
                          <div class="btn-sm">
                            <button class="btn btn-white btn-sm" type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                              <span class="icon icon24 menu"></span>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                              <li (click)="attrGroup(group, dealService.favoriteAttrId, true)"
                                  *ngIf="!hasGroupAttr(group, dealService.favoriteAttrId)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 star"></span>Favorite
                                </a>
                              </li>
                              <li
                                (click)="attrGroup(group, dealService.favoriteAttrId, false)"
                                *ngIf="hasGroupAttr(group, dealService.favoriteAttrId)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 star-filled"></span>Unfavorite
                                </a>
                              </li>
                              <li (click)="attrGroup(group, dealService.pinnedAttrId, true)"
                                  *ngIf="!hasGroupAttr(group, dealService.pinnedAttrId)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 pin"></span>Pin
                                </a>
                              </li>
                              <li (click)="attrGroup(group, dealService.pinnedAttrId, false)"
                                  *ngIf="hasGroupAttr(group, dealService.pinnedAttrId)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 pin-filled"></span>Unpin
                                </a>
                              </li>
                              <li (click)="attrGroup(group, dealService.hiddenAttrId, true)"
                                  *ngIf="!hasGroupAttr(group, dealService.hiddenAttrId)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 eye-hide"></span>Hide
                                </a>
                              </li>
                              <li (click)="attrGroup(group, dealService.hiddenAttrId, false)"
                                  *ngIf="hasGroupAttr(group, dealService.hiddenAttrId)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 eye"></span>Show
                                </a>
                              </li>
                              <li (click)="shareGroup(group)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 share"></span>Share
                                </a>
                              </li>
                              <li>
                                <hr class="dropdown-divider"/>
                              </li>
                              <li (click)="removeGroup(group)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 trash text-danger"></span>Remove
                                </a>
                              </li>
                              <li>
                                <a class="dropdown-item cursor-pointer disabled">
                                  <span class="icon icon24 warning text-danger"></span>Report SCAM
                                </a>
                              </li>
                              <li>
                                <hr class="dropdown-divider"/>
                              </li>
                              <li>
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 branch"></span>{{ group.deals.length }} items
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="row collapse border-bottom cursor-pointer align-items-center pe-2 deal"
                           *ngFor="let deal of group.deals"
                           [ngClass]="{'show' : group.expandGroup || group.deals.length === 1}"
                           [style.border-left-color]="d.getAttributeValue(deal.attributes, dealService.colorAttrId)">
                        <div class="col-5 overflow-hidden text-truncate ml--4">
                          <div class="checkbox icon icon24"
                               (click)="deal.selected = !deal.selected"
                               [ngClass]="deal.selected ? 'checked-checkbox' : 'unchecked-checkbox'"></div>

                          <div class="d-inline">
                            {{ deal.fromToken.symbol }}
                            <span class="d-lg-inline d-none">
                              {{ deal.toToken.symbol }}
                            </span>
                          </div>
                        </div>

                        <div class="col-2">
                          <span [ngClass]="deal.profit > 0? 'text-success' : 'text-danger'"
                                *ngIf="!d.getAttributeValue(deal.attributes, dealService.inOrderAttrId, false)">
                            ${{ format(abs(deal.profit)) }}
                          </span>
                          <small class="text-muted d-block mt--4">
                            ${{ format(deal.price * deal.quantity) }}
                          </small>
                        </div>

                        <div class="col-2">
                          <span *ngIf="!d.getAttributeValue(deal.attributes, dealService.inOrderAttrId, false)"
                                [ngClass]="deal.profit > 0? 'text-success' : 'text-danger'">
                            {{ format(abs(((deal.last_price / deal.price) * 100) - 100)) }}%
                          </span>
                          <small class="text-muted d-block mt--4">
                            {{ format(deal.quantity) }}
                          </small>
                        </div>

                        <div class="col text-end">
                          <div class="btn-sm">
                            <button class="btn btn-white btn-sm" type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                              <span class="icon icon24 menu"></span>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                              <li>
                                <a class="dropdown-item cursor-pointer" (click)="openDeal(deal)">
                                  <span class="dropdown-item icon icon24 edit"></span>Edit
                                </a>
                              </li>
                              <li (click)="d.attrCreate(deal, dealService.favoriteAttrId, true)"
                                  *ngIf="!d.getAttributeValue(deal.attributes, dealService.favoriteAttrId, false)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 star"></span>Favorite
                                </a>
                              </li>
                              <li
                                (click)="d.attrDelete(deal, d.getAttribute(deal.attributes, dealService.favoriteAttrId).id)"
                                *ngIf="d.getAttributeValue(deal.attributes, dealService.favoriteAttrId, false)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 star-filled"></span>Unfavorite
                                </a>
                              </li>
                              <li (click)="d.attrCreate(deal, dealService.pinnedAttrId, true)"
                                  *ngIf="!d.getAttributeValue(deal.attributes, dealService.pinnedAttrId, false)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 pin"></span>Pin
                                </a>
                              </li>
                              <li
                                (click)="d.attrDelete(deal, d.getAttribute(deal.attributes, dealService.pinnedAttrId).id)"
                                *ngIf="d.getAttributeValue(deal.attributes, dealService.pinnedAttrId, false)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 pin-filled"></span>Unpin
                                </a>
                              </li>
                              <li (click)="d.attrCreate(deal, dealService.hiddenAttrId, true)"
                                  *ngIf="!d.getAttributeValue(deal.attributes, dealService.hiddenAttrId, false)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 eye-hide"></span>Hide
                                </a>
                              </li>
                              <li
                                (click)="d.attrDelete(deal, d.getAttribute(deal.attributes, dealService.hiddenAttrId).id)"
                                *ngIf="d.getAttributeValue(deal.attributes, dealService.hiddenAttrId, false)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 eye"></span>Show
                                </a>
                              </li>
                              <li (click)="shareDeal(deal)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 share"></span>Share
                                </a>
                              </li>
                              <li>
                                <hr class="dropdown-divider"/>
                              </li>
                              <li (click)="d.remove(deal.id)">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 trash text-danger"></span>Remove
                                </a>
                              </li>
                              <li>
                                <a class="dropdown-item cursor-pointer disabled">
                                  <span class="icon icon24 warning text-danger"></span>Report SCAM
                                </a>
                              </li>
                              <li>
                                <hr class="dropdown-divider"/>
                              </li>
                              <li title="{{deal.created | date:dateFormat}}">
                                <a class="dropdown-item cursor-pointer">
                                  <span class="icon icon24 time"></span>
                                  <span>
                                    {{ formatTime(deal.created) }}<br/>
                                    <small class="text-muted"
                                           style="float: left; margin-left: 30px; margin-top: -8px; font-size: 10px;">{{
                                        formatDate(deal.created) | date:'yyyy-MM-dd'
                                      }}</small>
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-5 col-xl-6" [ngClass]="{'d-none' : isVisible('details')}">
            <div class="row">
              <div class="col-lg-12">
                <div class="block border">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-block border-bottom p-2"
                           (click)="apiService.setParams({'$action' : null, '$deal' : null})">
                        <span
                          class="icon icon24 back-arrow d-lg-none"></span>{{ 'app.labels.deal.details' | translate }}
                        <button type="button" class="btn-close float-end"
                                *ngIf="apiService.getParam('$deal') || apiService.getParam('$action') === 'add-deal'"></button>
                      </div>
                      <div class="overflow-x-hidden overflow-y-auto scrollbar" style="max-height: calc(100vh - 176px);">
                        <div class="text-center"
                             *ngIf="!apiService.getParam('$deal') && apiService.getParam('$action') != 'add-deal'">
                          <div class="icon icon24 no-deals my-5" style="transform: scale(5); opacity: .7"></div>
                          <p class="mb-5" *ngIf="getSelectedDealCount() === 0">
                            Select an deal to read
                            <br/>
                            Nothing is selected
                          </p>
                          <p class="mb-5" *ngIf="getSelectedDealCount() > 0">
                            Selected {{ getSelectedDealCount() }} deals
                          </p>
                        </div>
                        <deal
                          [ngClass]="{'d-none' : !apiService.getParam('$deal') && apiService.getParam('$action') != 'add-deal'}"></deal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <modal #od>
    <ul>
      <li *ngFor="let outOrder of getOutOrders()">
        <div class="row">
          <div class="col-6">{{ jsonParse(outOrder.value).price }}</div>
          <div class="col-6 text-end">{{ jsonParse(outOrder.value).quantity }}</div>

          <div class="col-12">
            <button class="btn btn-sm" type="button" (click)="removeOutOrder(outOrder)">
              <span class="icon icon24 trash"></span>
            </button>
            <button class="btn btn-sm" type="button" (click)="executedOutOrder(outOrder)">
              <span class="icon icon24 double-done"></span>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </modal>

  <div class="modal fade" id="addFolder" data-bs-backdrop="static"
       data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Create new folder</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <label class="form-label" for="name" translate>app.folder.name</label>
              <input type="text" id="name" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="folder.name"
                     placeholder="{{'app.folder.name.example' | translate}}"/>
              <div *ngIf="folder.error">{{ folder.error }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal"
                  translate>app.folder.button.cancel
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="folderService.add($event, folder)"
                  translate>app.folder.button.create
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="addAccount" data-bs-backdrop="static"
       data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Create new account</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-4" [innerHTML]="'app.account.description' | translate"></div>
            <div class="col-12">
              <label class="form-label" for="account_name" translate>app.account.name</label>
              <input type="text" id="account_name" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="account.name"
                     placeholder="{{'app.account.name.example' | translate}}"/>
            </div>
            <div class="col-12">
              <label class="form-label" for="account_address" translate>app.account.address</label>
              <input type="text" id="account_address" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="account.address"
                     placeholder="{{'app.account.address.example' | translate}}"/>
            </div>
            <div *ngIf="account.error">{{ account.error }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary"
                  data-bs-dismiss="modal" translate>app.account.button.close
          </button>
          <button type="button" class="btn btn-sm btn-primary"
                  (click)="accountService.add($event, account)" translate>app.account.button.add
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
